import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthLayout } from "@/components/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [testMode, setTestMode] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMessage(data.message);
      setTestMode(!!data.test_mode);
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Passwort vergessen"
      subtitle="Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen sicheren Link zum Zurücksetzen Ihres Passworts."
      testid="forgot-password-page"
    >
      {message ? (
        <div className="text-center space-y-6">
          <p className="text-charcoal/70 leading-relaxed" data-testid="forgot-success-message">
            {message}
          </p>
          {testMode && (
            <p className="text-sm text-charcoal/70 bg-muted border border-sand rounded-sm px-4 py-3 text-left leading-relaxed" data-testid="forgot-testmode-notice">
              <span className="font-medium text-charcoal">Hinweis – Testmodus:</span> Die
              Anwendung befindet sich derzeit im Testmodus. Es wird noch keine echte E-Mail
              versendet – der Link zum Zurücksetzen wurde im System-Protokoll hinterlegt.
              Sobald der E-Mail-Versand aktiviert ist, erhalten Sie den Link automatisch per E-Mail.
            </p>
          )}
          <Link to="/login">
            <Button className="w-full bg-gold hover:bg-golddark text-white rounded-sm py-6 transition-colors duration-500" data-testid="back-to-login-button">
              Zurück zur Anmeldung
            </Button>
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-6">
          {error && (
            <p className="text-sm text-destructive bg-destructive/5 border border-destructive/20 rounded-sm px-4 py-3" data-testid="forgot-error">
              {error}
            </p>
          )}
          <div className="space-y-2">
            <Label htmlFor="email">E-Mail</Label>
            <Input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-email-input"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-gold hover:bg-golddark text-white rounded-sm py-6 transition-colors duration-500"
            data-testid="forgot-submit-button"
          >
            {loading ? "Wird gesendet…" : "Link anfordern"}
          </Button>
          <p className="text-center text-sm">
            <Link to="/login" className="text-gold hover:text-golddark transition-colors duration-500">
              Zurück zur Anmeldung
            </Link>
          </p>
        </form>
      )}
    </AuthLayout>
  );
}
